<ng-template #content>
  <ng-content></ng-content>
</ng-template>

<div
  *ngIf="action === 'disable' && isBlockedAccess"
  class="role-access__wrapper"
  [ngbPopover]="message"
  triggers="mouseenter:mouseleave"
  (mouseenter)="handleMouseEvent()"
  (mouseleave)="handleMouseEvent()"
  [placement]="placement"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>
<div *ngIf="action === 'disable' && !isBlockedAccess" class="role-access__wrapper-access">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>
<div *ngIf="action === 'visible' && !isBlockedAccess" class="role-access__wrapper">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>
